import { Component, input } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReportControl } from '@xmedical/core';

@Component({
  selector: 'xmed-billing-icd10-list-renderer',
  standalone: true,
  imports: [
    MatListModule,
    MatFormFieldModule
  ],
  templateUrl: './billing-icd10-list-renderer.component.html',
  styleUrl: './billing-icd10-list-renderer.component.scss'
})
export class BillingIcd10ListRendererComponent {
  control = input.required<ReportControl>();
}
